<template>
  <div v-if="partners && partners.length && !loading" class="my-5">
    <div class="d-flex flex-wrap justify-content-between align-items-center">
        <h2 class="font-weight-bolder text-primary my-3 h5">{{ $t('BrandComplex.partners') }}</h2>
        <div class="align-self-center">
            <brandSeeAllBtn :settingsPerm="settingsPerm" queryType="PARTNERS"/>
        </div>
    </div>
    <section
      :id="'splide-' + randomId"
      class="splide splide-partners px-0"
      aria-label="partners logo slider"
    >
      <div class="splide__track mask-container">
        <div class="splide__list d-flex align-items-stretch">
          <div
            v-for="partner in partners"
            :key="partner.id"
            class="splide__slide partner-list-single-element-wrapper text-center my-2 d-flex"
          >
            <singlePartnerFeature :partner="partner" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  ApolloClient,
  InMemoryCache
} from '@apollo/client/core';
import { provideApolloClient, useQuery } from '@vue/apollo-composable';
import { watch } from 'vue';
import Splide from '@splidejs/splide';
import CONCORD_QUERIES from '../../services/concord_queries.js';
import singlePartnerFeature from './singlePartnerFeature.vue';
import brandSeeAllBtn from './brandSeeAllBtn.vue';

export default {
  name: "partnersFeature",
  props: {
    settingsPerm: Object,
    brandData: Object
  },
  data() {
    return {
      randomId: Math.random().toString(36).substring(2, 15),
      partners: [],
      loading: true,
      splide: null,
      page: 1,
      pageSize: 20,
      sliderPerPage: 4,
      metaCount: 0,
    }
  },
  components: {
    singlePartnerFeature,
    brandSeeAllBtn
  },
  created() {
    if (this.brandData && this.brandData !== null) {
      this.getBrandPartners();
    }
  },

  methods: {
    getBrandPartners(){
      const cache = new InMemoryCache();
      const customHeaders = {
        platform: "web",
        App: this.settingsPerm.isDevMioActive ? "devmio" : "entwickler"
      };
      const apolloClient = new ApolloClient({
        cache,
        uri: this.settingsPerm.concordBackendURL,
        headers: customHeaders,
      });
      provideApolloClient(apolloClient);
        const { result } = useQuery(CONCORD_QUERIES.GET_BRAND_PARTNERS, {
          brandComplexId: this.brandData,
          page: this.page,
          pageSize: this.pageSize
      });

      watch(result, (value) => {
        if (value?.platformPartners?.PlatformPartners?.length) {
          this.metaCount = value.platformPartners.Meta?.count || 0;
          this.partners = [...this.partners, ...value.platformPartners.PlatformPartners];
          this.loading = false;
          this.$nextTick(() => {
            if (!this.splide) {
              this.mountSplide();
            } else {
              this.splide.refresh();
            }
          });
        }
      });
    },
    mountSplide() {
      let thiz = this;
      let padding = {
        right: "0rem",
        left: "0rem",
      };

      setTimeout(function () {
        if (thiz.partners && thiz.partners.length && thiz.partners.length > 3) {
          padding = {
            right: "0rem",
            left: "0rem",
          };
        }

        if (!thiz.splide) {
          thiz.splide = new Splide(`#splide-${thiz.randomId}`, {
            classes: {
              arrows: 'splide__arrows arrows',
              arrow: 'splide__arrow arrow',
              prev: 'splide__arrow--prev prev',
              next: 'splide__arrow--next next',
            },
            perPage: 4,
            perMove: 1,
            gap: '1rem',
            rewind: false,
            pagination: false,
            padding: padding,
            breakpoints: {
              1600: { perPage: 4 },
              1280: { perPage: 3 },
              991: { perPage: 3 },
              767: { 
                perPage: 2,
              },
              575: {
                perPage: 2,
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
              480: {
                perPage: 1,
                arrows: false,
                padding: { left: "0rem", right: "5rem" },
                start: 0,
              },
              320: { 
                perPage: 1, 
                arrows: false, 
                padding: { left: "0rem", right: "3rem" }, 
                start: 0 
              }
            },
          });

          thiz.splide.on("moved", (newIndex) => {
            const lastCardIndex = newIndex + thiz.sliderPerPage;
            if (thiz.partners.length < thiz.metaCount && lastCardIndex >= thiz.partners.length - 1) {
              thiz.page++;
              thiz.getBrandPartners();
            }
          });

          thiz.splide.mount();
        } else {
          thiz.splide.refresh(); // refresh existing instance
        }
      }, 500);
    }
  }
};
</script>

<style scoped>
</style>
